import QuestionObj from '../Models/QuestionObj';

const SalesExecutive_QSet = [    
    new QuestionObj({
        questionSet:{
            English: ' Are your applications integrated across all customer touchpoints to give you a full view of your customers’ journeys? ',
            German: 'German Q1',
            French: "French Q1",
            Russian: "Russian Q1",
            Turkish: "Turkish Q1",
            Italian: "Italian Q1",
            Spanish: "Spanish Q1",
            PortugueseBR: "PortugueseBR Q1",
            SpanishLAD: "SpanishLAD Q1",
        },
        answerSet:{
            English: [
                "No, our applications are siloed and disconnected",
                "Some applications are integrated, but the data isn’t connected or complete ",
                "Yes, our apps are integrated, and data is connected",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 66, 100],   
    }),
    new QuestionObj({
        questionSet:{
            English: 'Is AI built into your applications to automate and simplify the sales process?',
            German: 'German Q2',
            French: "French Q2",
            Russian: "Russian Q2",
            Turkish: "Turkish Q2",
            Italian: "Italian Q2",
            Spanish: "Spanish Q2",
            PortugueseBR: "PortugueseBR Q2",
            SpanishLAD: "SpanishLAD Q2",
        },
        answerSet:{
            English: [
                'No, we don’t have any AI in our applications',
                'We use AI in our applications, but our AI capabilities are an add-on, not built in',
                'We have built-in AI in some of our applications, but not all of them',
                'Yes, we use built-in AI in our applications',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50, 75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Does your CRM use digital tools, such as intelligent recommendations, to guide the sales experience?',
            German: 'German Q3',
            French: "French Q3",
            Russian: "Russian Q3",
            Turkish: "Turkish Q3",
            Italian: "Italian Q3",
            Spanish: "Spanish Q3",
            PortugueseBR: "PortugueseBR Q3",
            SpanishLAD: "SpanishLAD Q3",
        },
        answerSet:{
            English: [
                'No, sellers use different systems and applications to manually move the sales process forward',
                'Somewhat',
                'Yes, our CRM has embedded digital tools that guide sellers through the sales process',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,66,100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do your sellers have the customer data needed to engage digital buyers?',
            German: 'German Q4',
            French: "French Q4",
            Russian: "Russian Q4",
            Turkish: "Turkish Q4",
            Italian: "Italian Q4",
            Spanish: "Spanish Q4",
            PortugueseBR: "PortugueseBR Q4",
            SpanishLAD: "SpanishLAD Q4",
        },
        answerSet:{
            English: [
                "No, sellers do not have a complete view of all customer data",
                "Yes, sellers have all the customer intelligence needed to engage with digital customers",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 100], 
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can customers purchase your goods and services on any digital channel, with or without speaking to a rep?',
            German: 'German Q5',
            French: "French Q5",
            Russian: "Russian Q5",
            Turkish: "Turkish Q5",
            Italian: "Italian Q5",
            Spanish: "Spanish Q5",
            PortugueseBR: "PortugueseBR Q5",
            SpanishLAD: "SpanishLAD Q5",
        },
        answerSet:{
            English: [
                "No",
                "We support a few digital channels, but it's limited with no self-service capabilities",
                "Yes, we support most, but not all channels with limited self-service capabilities",
                "Yes, we let our customers purchase products and services on any digital channel with robust self-service capabilities on all channels",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50, 75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can you create, manage, and publish personalized content across any digital channel?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                "No, we struggle to publish content on digital channels due to internal and external roadblocks", 
                "We can publish content across channels, but it is a time-consuming and manual process for sellers to find and build the right content",
                "We can somewhat easily produce and deliver content across channels, but it is not personalized",
                "Yes, our sellers can create, manage, and publish personalized content across digital channels with ease. ",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50,75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do you offer a solution that allows you to deliver an end-to-end sales-to-order process, configuring quotes based on buyers’ unique needs?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                "No, we do not currently have a configure, price, and quote solution", 
                "We have a configure, price, and quote solution, but it does not have the functionality that we need to deliver a personalized experience for every customer",
                "Yes, our current solution allows us to deliver an end-to-end sales-to-order process",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 66, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can you support recurring revenue models?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                "No, we currently only support single transaction-based models", 
                "Yes, we support recurring revenue models",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,100],
    }),
];

export default SalesExecutive_QSet;